module.exports = {
    'BobTV the adult webcam chat since 2007': 'BobTV le tchat webcam pour adultes depuis 2007',
    'According to the French law, the permitted age is 18- Article 488 al. 1 of the Civil Code': 'Selon la Loi française, la majorité est fixée à 18 ans accomplis – Article 488 al. 1 du Code civil',
    'I confirm that I have read and accepted without reservation all the provisions contained in the ': 'Je certifie avoir lu et accepté sans réserves l’ensemble des dispositions contenues dans les ',
    'Terms and Conditions': 'Conditions Générales d’Utilisation',
    ' of this server.': ' de ce serveur.',
    'Exit': 'Sortir',
    'Confirm my majority': 'Confirmer ma majorité',
    'Accept and connect': 'Acepter et se connecter'
}


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/disclaimer.js